export type SettingsTab = "access" | "app" | "user" | "api-keys" | "audit";

interface SettingsTabsProps {
  active: SettingsTab;
  onChange: (tab: SettingsTab) => void;
}

const TABS: { id: SettingsTab; label: string; subtitle?: string }[] = [
  {
    id: "app",
    label: "Global Settings",
  },
  {
    id: "user",
    label: "User Settings",
  },
  {
    id: "api-keys",
    label: "API Keys",
  },
  { id: "access", label: "User Access" },
  { id: "audit", label: "Audit Log" },
];

export function SettingsTabs({ active, onChange }: SettingsTabsProps) {
  const activeSubtitle = TABS.find((tab) => tab.id === active)?.subtitle;

  return (
    <div className="settings-tabs-header">
      <nav className="settings-tabs" role="tablist" aria-label="Settings sections">
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active === tab.id}
            className={`settings-tabs__tab ${active === tab.id ? "settings-tabs__tab--active" : ""}`}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}
